import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../../General/PrintHeader";
import Page from "../../General/Page";
import { getMonthName } from "../../General/Utility";

const PrintTaxList = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [selectedYear, setselectedYear] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");
  const [totalTax, settotalTax] = useState("");

  useEffect(() => {
    document.title = "DPS School Management System";

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const year = urlParams.get("year");
    const Month = urlParams.get("month");
    const EmployeeTypeId = urlParams.get("EmployeeTypeId");

    setselectedYear(year);
    setselectedMonth(Month);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Fyear: year,
      SelectedMonth: Month,
      EmployeeTypeId: EmployeeTypeId,
    };

    // console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetTaxList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    console.log(data);

    axios(api_config)
      .then(function (response) {
        console.log(response.data);
        setLedger(response.data.ListofRecords);
        settotalTax(response.data.totalTax);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      let countbreak = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++}</td>
            <td>{item.SelectedEmployee?.Code}</td>
            <td>{item.SelectedEmployee?.Name}</td>
            <td>{item.SelectedEmployee?.Father_Name}</td>
            <td>{item.SelectedEmployee?.SelectedDesignation?.Name}</td>
            <td>{item.SelectedEmployee?.Qualification}</td>
            <td>{item.SelectedEmployee?.GPS_Scale}</td>
            <td></td>
            <td>{item.SelectedEmployee?.NTN_NO}</td>
            <td>{item.Gross}</td>
            <td>{item.Tax}</td>
            <td>{item.SelectedEmployee?.Mobile_No}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colspan="12">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <Page orientation="landscape" size="legal">
        <table className="table print-main-table">
          <thead>
            <tr>
              <td>
                <PrintHeader
                  title={`Salary Sheet For the Month of ${getMonthName(
                    selectedMonth
                  )} ${selectedYear} `}
                />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table className="table table-sm table-bordered table-print">
                  <tbody>
                    <tr>
                      <th  >Sr.#</th>
                      <th >Code</th>
                      <t >Staff Name </t>
                      <th  >Father Name </th>
                      <th style={{ width: "120px" }}>Designation</th>
                      <th style={{ width: "160px" }}>Qualification </th>
                      <th style={{ width: "50px" }}>BPS </th>
                      <th style={{ width: "120px" }}>CNIC No. </th>
                      <th style={{ width: "120px" }}>NTN No. </th>
                      <th>Gross </th>
                      <th style={{ width: "100px" }}>Tax Paid </th>
                      <th style={{ width: "120px" }}>Mobile No </th>
                    </tr>
                    {loading ? (
                      <tr>
                        <td className="text-center" colspan="16">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {renderLedger()}
                        <tr>
                          <th className="text-end" colspan="10">
                            Total Tax :
                          </th>
                          <th colspan="2">{totalTax}</th>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintTaxList;
